<script>
import Button from '@/Components/Button/Button';

export default {
    extends: Button,

    props: {
        icon: {
            type: String,
            default: 'pencil',
        },
        size: {
            type: String,
            default: 'xs',
        },
        color: {
            type: String,
            default: 'orange',
        },
        label: {
            type: String,
            default: function() {
                return this.$t('form.edit');
            },
        },
    },
};
</script>
